import React from 'react';
import 'twin.macro';
import { Title } from '../text';
import { Divider } from './Divider';

export const DividerTitle = ({ title, ...restProps }) => (
  <div tw='w-full flex flex-row items-center py-4 first-of-type:pt-0' {...restProps}>
    <Title Type='h3' tw='pr-3' marginBottom={false}>
      {title}
    </Title>
    <div tw='flex-grow'>
      <Divider tw='my-0' />
    </div>
  </div>
);
